import { render } from "./ResidentAdl.vue?vue&type=template&id=0dd521c0"
import script from "./ResidentAdl.vue?vue&type=script&lang=js"
export * from "./ResidentAdl.vue?vue&type=script&lang=js"

import "./ResidentAdl.vue?vue&type=style&index=0&id=0dd521c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__